import { MessageCircle } from "lucide-react";
import { useDocstate } from "@/context/DocstateContext";

// One-tap "WhatsApp Sara" launcher shown across the whole Docstate site.
// Appears only once a public WhatsApp number is set in the backoffice.
export const WhatsAppFab = () => {
  const data = useDocstate();
  const num = (data?.settings?.whatsapp || "").replace(/[^\d]/g, "");
  if (!num) return null;
  const href = `https://wa.me/${num}?text=${encodeURIComponent(
    "Hi Sara, I'm interested in Dubai property. Can you help me find the right home?"
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat with Sara on WhatsApp"
      className="group fixed bottom-5 left-5 z-[55] flex items-center gap-2 rounded-full bg-[#25D366] py-3.5 pl-4 pr-5 text-sm font-semibold text-white shadow-2xl shadow-[#25D366]/30 transition-transform hover:scale-105"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap opacity-0 transition-all duration-300 group-hover:max-w-[140px] group-hover:opacity-100">
        WhatsApp Sara
      </span>
    </a>
  );
};
